import { CheckIcon, InfoIcon, AlertTriangleIcon } from 'lucide-react';
import React from 'react';
import { Button } from '../../../../components/ui/button';
import { Box, Typography } from '@mui/material';

interface AvailabilityButtonSectionProps {
  selectedCount: number;
  submitAvailability: () => void;
  minRequired: number;
}

export const AvailabilityButtonSection = ({
  selectedCount,
  submitAvailability,
  minRequired,
}: AvailabilityButtonSectionProps): JSX.Element => {
  const hasMinimumSlots = selectedCount >= minRequired;
  const remainingSlots = Math.max(0, minRequired - selectedCount);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        width: 'calc(100% - 32px)',
        maxWidth: '480px',
        bgcolor: 'white',
        borderTop: '1px solid #e5e7eb',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          p: 3,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 2,
            width: '100%',
          }}
        >
          {selectedCount > 0 && hasMinimumSlots && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckIcon size={16} color="#2a9e56" />
              <Typography variant="body2" sx={{ color: '#2a9e56' }}>
                {selectedCount} time slot{selectedCount !== 1 ? 's' : ''} selected
              </Typography>
            </Box>
          )}

          {selectedCount > 0 && !hasMinimumSlots && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AlertTriangleIcon size={16} color="#f59e0b" />
              <Typography variant="body2" sx={{ color: '#f59e0b' }}>
                {selectedCount} of {minRequired} minimum time slots selected
                {remainingSlots > 0 && ` (${remainingSlots} more needed)`}
              </Typography>
            </Box>
          )}

          {selectedCount === 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <InfoIcon size={16} color="#6b7280" />
              <Typography variant="body2" sx={{ color: '#6b7280' }}>
                Select at least {minRequired} time{minRequired === 1 ? ' slot ' : ' slots '}to
                continue
              </Typography>
            </Box>
          )}

          <Button
            fullWidth
            sx={{
              height: 38,
              backgroundColor: '#0f4bff',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              color: 'white',
              '&:hover': {
                backgroundColor: '#0f4bffcc',
              },
              '&:disabled': {
                opacity: 0.5,
                cursor: 'not-allowed',
              },
            }}
            onClick={submitAvailability}
            disabled={!hasMinimumSlots}
          >
            SUBMIT AVAILABILITY
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
